(() => {
  const initialize = (root = document) => {
    root.querySelectorAll('[data-mag-reading-page]').forEach((page) => {
      if (page.dataset.magReadingReady) return;
      page.dataset.magReadingReady = 'true';
      const body = page.querySelector('[data-mag-reading-body]');
      const nav = page.querySelector('[data-mag-reading-toc]');
      if (!body || !nav) return;
      const headings = [...body.querySelectorAll('h2')].filter((heading) => heading.textContent.trim());
      if (headings.length < 2) return;
      const list = nav.querySelector('ol');
      headings.forEach((heading, index) => {
        if (!heading.id) heading.id = `reading-${index + 1}-${heading.textContent.trim().toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '')}`;
        const item = document.createElement('li');
        const link = document.createElement('a');
        link.href = `#${heading.id}`;
        link.textContent = heading.textContent;
        item.append(link);
        list.append(item);
      });
      nav.hidden = false;
    });
    root.querySelectorAll('[data-mag-contact-topic]').forEach((select) => {
      if (select.dataset.magContactReady) return;
      select.dataset.magContactReady = 'true';
      const help = select.closest('form')?.querySelector('[data-mag-contact-help]');
      const hints = {
        'Fragrance advice': 'Tell us the scents you enjoy, your budget and where you plan to wear it.',
        'Order help': 'Include your order number and the email address used at checkout. Please do not send payment-card details.',
        'Return or product concern': 'Include your order number and describe the concern so we can direct your request.',
        'Business enquiry': 'Tell us about your business and the collaboration you have in mind.',
        'Something else': 'Tell us a little about what you need.'
      };
      select.addEventListener('change', () => { if (help) help.textContent = hints[select.value] || hints['Something else']; });
    });
    const policy = root.querySelector('.shopify-policy__body');
    if (policy && !policy.dataset.magPolicyReady) {
      policy.dataset.magPolicyReady = 'true';
      const headings = [...policy.querySelectorAll('h2,h3')].filter((heading) => heading.textContent.trim());
      if (headings.length > 2) {
        const disclosure = document.createElement('details');
        disclosure.className = 'mag-policy-toc';
        const summary = document.createElement('summary');
        summary.textContent = 'On this page';
        const list = document.createElement('ol');
        headings.forEach((heading, index) => {
          if (!heading.id) heading.id = `policy-section-${index + 1}`;
          const item = document.createElement('li');
          const link = document.createElement('a');
          link.href = `#${heading.id}`;
          link.textContent = heading.textContent;
          item.append(link); list.append(item);
        });
        disclosure.append(summary, list);
        policy.prepend(disclosure);
      }
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  else initialize();
  document.addEventListener('shopify:section:load', () => initialize());
})();
